import { useEffect } from "react";
import { useOutletContext } from "react-router";

import FlashContext from "components/FlashMessages/FlashContext";
import usePrevious from "hooks/usePrevious";
import useTypedContext from "hooks/useTypedContext";
import { isScanRunInProgress } from "shared/Scan/access/useCanTriggerScan";

import { ScanResourcesOutletContext } from "../types";

const useScanResourcesRefetchOnRunFinish = (refetch: () => Promise<unknown>) => {
  const { onError } = useTypedContext(FlashContext);
  const { run } = useOutletContext<ScanResourcesOutletContext>();

  const runId = run?.id;
  const runState = run?.state;
  const previousRunState = usePrevious(runState);

  useEffect(() => {
    if (!runId) {
      return;
    }

    if (!isScanRunInProgress(previousRunState) || isScanRunInProgress(runState)) {
      return;
    }

    refetch().catch(onError);
  }, [runId, runState, previousRunState, onError, refetch]);
};

export default useScanResourcesRefetchOnRunFinish;
